__turbopack_context__.v({
  "card": "style-module-scss-module__umuY-W__card",
  "description": "style-module-scss-module__umuY-W__description",
  "lottie": "style-module-scss-module__umuY-W__lottie",
  "title": "style-module-scss-module__umuY-W__title",
});
